import * as types from '../../constants/ActionTypes'

const initialState = {
  show: [],
}

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_NOTIFICATION:
      return {
        ...state,
        show: [
          {
            ...state.show,
            message: action.message,
            kind: action.kind,
          },
        ],
      }
    default:
      return state
  }
}

export default notificationsReducer



// WEBPACK FOOTER //
// ./src/redux/modules/notifications.ts